export const LOAD_PAGES = 'LOAD_PAGES';
export const SET_LAYOUT_TO_ACTIVE_PAGE = 'SET_LAYOUT_TO_ACTIVE_PAGE';
export const ADD_LAYOUT_TO_PAGE = 'ADD_LAYOUT_TO_PAGE';
export const ADD_TEXTURE_TO_PAGE = 'ADD_TEXTURE_TO_PAGE';
export const CREATE_PAGE = 'CREATE_PAGE';
export const DELETE_PAGE = 'DELETE_PAGE';
export const DELETE_PAGES = 'DELETE_PAGES';
export const TOGGLE_IS_ACTIVE = 'TOGGLE_IS_ACTIVE';
export const REMOVE_PLACEHOLDERS_FROM_PAGE = 'REMOVE_PLACEHOLDERS_FROM_PAGE';
export const REMOVE_TEXTURE_FROM_PAGE = 'REMOVE_TEXTURE_FROM_PAGE';
export const ADD_DROPPED_IMAGE_TO_PAGE = 'ADD_DROPPED_IMAGE_TO_PAGE';
export const ADD_DROPPED_IMAGE = 'ADD_DROPPED_IMAGE';
export const REMOVE_DROPPED_IMAGE = 'REMOVE_DROPPED_IMAGE';
export const REMOVE_DROPPED_IMAGES = 'REMOVE_DROPPED_IMAGES';
export const UPDATE_PAGES_ORDER = 'UPDATE_PAGES_ORDER';
export const CHANGE_IMAGE = 'CHANGE_IMAGE';
export const ADD_COVER_TO_PAGE = 'ADD_COVER_TO_PAGE';
export const ADD_DROPPED_IMAGE_CHANGED_LAYOUT = 'ADD_DROPPED_IMAGE_CHANGED_LAYOUT';
export const REMOVE_CHANGED_IMAGE = 'REMOVE_CHANGED_IMAGE';
export const REORDER_PAGES = 'REORDER_PAGES';
export const REORDER_DROPPED_IMAGES = 'REORDER_DROPPED_IMAGES';
export const REORDER_PLACHOLDERS = 'REORDER_PLACHOLDERS';
export const ASSIGNE_IMAGE_ID_TO_PAGE_PLACEHOLDERS = 'ASSIGNE_IMAGE_ID_TO_PAGE_PLACEHOLDERS';
export const CHANGE_PAGES_BACKGROUND_COLOR = 'CHANGE_PAGES_BACKGROUND_COLOR';
export const CHANGE_PAGES_BACKGROUND_COLOR_BY_ID = 'CHANGE_PAGES_BACKGROUND_COLOR_BY_ID';
export const LOAD_PAGES_BY_BOOK_ID = 'LOAD_PAGES_BY_BOOK_ID';
export const ADD_TEXT_TO_PAGE = 'ADD_TEXT_TO_PAGE';
export const DELETE_TEXT_FROM_PAGE = 'DELETE_TEXT_FROM_PAGE';
export const ADD_BACKGROUND_IMAGE_TO_PAGE = 'ADD_BACKGROUND_IMAGE_TO_PAGE';
export const CHANGE_PAGES_BACKGROUND_IMAGES = 'CHANGE_PAGES_BACKGROUND_IMAGES';
export const ADD_BACKGROUND_PLACEHOLDER_TO_PAGE = 'ADD_BACKGROUND_PLACEHOLDER_TO_PAGE';
export const ADD_DATE_PLACEHOLDER_TO_PAGE = 'ADD_DATE_PLACEHOLDER_TO_PAGE';



// WEBPACK FOOTER //
// ./src/redux/action-types/entities/pages.js